import React from 'react';
import styled from 'styled-components';
import { PrimaryBtn } from '@panel/commons/lib/Button';
import { selectColor } from '@panel/commons/core';
import { useTranslation } from 'react-i18next';
import Atencion from '../../../assets/img/atencion.svg';

const LockedManualModal = ({ onClose, isZPARSite }) => {
  const { t } = useTranslation();

  return (
    <Container isZPARSite={isZPARSite}>
      <Img src={Atencion} isZPARSite={isZPARSite} />
      <div className='container-info'>
        <h3>{t('panel.avisos.alert.title.modal.lockedManual')}</h3>
        {!isZPARSite && <p>{t('panel.avisos.alert.descrip.modal.lockedManual')}</p>}
        {isZPARSite && (
          <div className='info-zpar'>
            <p className='text'>{t('panel.avisos.alert.descrip.modal.lockedManual.1')}</p>
            <strong>
              {t('panel.avisos.alert.descrip.modal.lockedManual.phone')} <br />{' '}
              {t('panel.avisos.alert.descrip.modal.lockedManual.mail')}
            </strong>
            <p className='text'>{t('panel.avisos.alert.descrip.modal.lockedManual.2')}</p>
          </div>
        )}
      </div>
      <div className='button-container'>
        <PrimaryBtn type='submit' onClick={onClose} borderRadius='8px' hoverColor='secondary'>
          {t('panel.avisos.alert.CTA1.modal.lockedManual')}
        </PrimaryBtn>
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding: 24px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .container-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin-top: ${({ isZPARSite }) => isZPARSite && '40px'};
    .info-zpar {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      margin-bottom: 16px;
      .text {
        color: ${selectColor('black')};
      }
      strong {
        text-align: center;
      }
    }
  }
  .button-container {
    width: ${({ isZPARSite }) => (isZPARSite ? '100%' : '50%')};
  }
  h3 {
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
  }
  p {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
    color: ${selectColor('grayDark')};
  }

  > a {
    height: 48px;
  }
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  width: 145px;
  height: 96px;
  margin-top: ${({ isZPARSite }) => isZPARSite && '30px'};
`;

export default LockedManualModal;
